import React from "react";

export default function MySQL_STRCMP() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_STRCMP</h1>
      <p>This is the MySQL_STRCMP component generated from the SQL JSON.</p>
    </div>
  );
}
